export default {
  token: localStorage.getItem('access_token') || null,
  user: {},
}